var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"id":_vm.id,"value":_vm.multiple ? _vm.value || [] : _vm.value,"options":_vm.ecosystemOptions,"multiple":_vm.multiple,"select-size":_vm.multiple ? 8 : 0,"required":_vm.required},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }